import request from "../Requests/requests";
import { loadDataCheckList } from "../store/chekListReducer";

export const getCheckList = (taskId) => {
    return async (dispatch) => {
        const response = await request.get('/Checklist', {
            params: {TaskId: taskId }})
        dispatch(loadDataCheckList(response.data))
    }
    }